import { gql } from 'graphql-request';

const QuickNavigationItem = gql`
  fragment QuickNavigationItem on QuickNavigationItemBlock {
    linkText
    id
    page {
      title
      url
    }
  }
`;

const QuickNavigation = gql`
  fragment QuickNavigation on QuickNavigationBlock {
    blockType
    title
    items {
      ...QuickNavigationItem
    }
  }
  ${QuickNavigationItem}
`;
export { QuickNavigation, QuickNavigationItem };
